import { Data } from './data';
import { ApiFile } from './apifile';

export class Message extends Data {

    content: string;
    email: string;
    objet: string;
    phone: string;
    pieces_jointes: ApiFile[]
    sender: string;

    constructor() {

        super();
        // this.date_publish = ( new Date()).toISOString().split('T')[0];
        
    }

    get nbrFichier(): number {

      if(this.pieces_jointes !== undefined && this.pieces_jointes !== null)
      return this.pieces_jointes.length;
      else
      return 0;
      
    }

    
    
    
    
}